import { render, staticRenderFns } from "./Billing.vue?vue&type=template&id=47ec7da6&scoped=true&"
import script from "./Billing.vue?vue&type=script&lang=ts&"
export * from "./Billing.vue?vue&type=script&lang=ts&"
import style0 from "./Billing.vue?vue&type=style&index=0&id=47ec7da6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ec7da6",
  null
  
)

export default component.exports